
/**
 * @param {monaco.editor.IStandaloneCodeEditor} editor
 */
export function toggleInlineStyle(editor, marker, placeholder) {
	const range = editor.getSelection();
	// 只支持当行的样式切换，多行再说
	if (range.startLineNumber !== range.endLineNumber) {
		return;
	}
	if (isInStyle(editor, range, marker)) {
		removeStyle(editor, range, marker);
	}
	else {
		addStyle(editor, range, marker, placeholder);
	}
}

/**
 * @param {monaco.editor.IStandaloneCodeEditor} editor
 * @param {monaco.Selection} range
 * @param {string} marker
 */
function isInStyle(editor, range, marker) {
	const model = editor.getModel();
	const lineNumber = range.getStartPosition().lineNumber;
	const rangeBefore = new monaco.Selection(
		lineNumber,
		range.startColumn - marker.length,
		lineNumber,
		range.startColumn
	);
	const rangeAfter = new monaco.Selection(
		lineNumber,
		range.endColumn,
		lineNumber,
		range.endColumn + marker.length
	);
	return model.getValueInRange(rangeBefore) === marker
		&& model.getValueInRange(rangeAfter) === reverse(marker);
}

function reverse(marker) {
	return marker ? marker.split('').reverse().join('') : marker;
}

/**
 * @param {monaco.editor.IStandaloneCodeEditor} editor
 * @param {monaco.Selection} range
 * @param {string} marker
 */
function addStyle(editor, range, marker, placeholder) {
	const originText = editor.getModel().getValueInRange(range) || placeholder;
	const styledText = `${marker}${originText}${reverse(marker)}`;

	const targetRange = new monaco.Selection(
		range.startLineNumber,
		range.startColumn + marker.length,
		range.startLineNumber,
		range.startColumn + marker.length + originText.length,
	);
	editor.executeEdits('replace', [{
		identifier: 'insert',
		range,
		text: styledText,
		forceMoveMarkers: true
	}], [targetRange]);
}

/**
 * @param {monaco.editor.IStandaloneCodeEditor} editor
 * @param {monaco.Selection} range
 * @param {string} marker
 */
function removeStyle(editor, range, marker) {
	const originText = editor.getModel().getValueInRange(range);
	const lineNumber = range.startLineNumber;
	const removeRange = new monaco.Selection(
		lineNumber,
		range.startColumn - marker.length,
		lineNumber,
		range.endColumn + marker.length,
	);
	const targetRange = new monaco.Selection(
		lineNumber,
		removeRange.startColumn,
		lineNumber,
		removeRange.startColumn + originText.length,
	);
	editor.executeEdits('replace', [{
		identifier: 'insert',
		range: removeRange,
		text: originText,
		forceMoveMarkers: true,
	}], [targetRange]);
}



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/actions/toggleInlineStyle.js